import React from "react"
import { graphql, StaticQuery } from "gatsby"

// List all pages excluding 404 page
const AllPostsQuery = ({ render }) => (
  <StaticQuery
    query={graphql`
      query blogIndex {
        allMdx(sort: { fields: [frontmatter___date], order: DESC }) {
          edges {
            node {
              id
              frontmatter {
                title
                date
                type
                customCard
                caption
                link
                linkAction
              }
              fields {
                slug
              }
            }
          }
        }
      }
    `}
    render={data => render(data)}
  />
)

export default AllPostsQuery
